import {
  ContactAddToType,
  contactsApi,
} from '@texas/api/endpoints/contactsApi';
import { useApiRequest } from '@texas/api/hooks/useApiRequest';
import { ContactsTable } from '@texas/components/contacts/ContactsTable';

export function SupplierContacts({
  supplierId,
  supplierName,
}: {
  supplierId: number;
  supplierName: string;
}) {
  const { request: disconnectRequest } = useApiRequest(
    contactsApi.disconnectSupplier,
  );
  const { request: connectRequest } = useApiRequest(
    contactsApi.connectSupplier,
  );

  return (
    <ContactsTable
      addToType={ContactAddToType.Supplier}
      referenceId={supplierId}
      referenceName={supplierName}
      disconnectRequest={disconnectRequest}
      connectRequest={connectRequest}
    />
  );
}
